<div class="slider-content-item-wrapper"
     [@translateSlide]="_position"  #slideInteraction>
  <div class="content-item-wrapper">
    <ng-content></ng-content>
  </div>
</div>

